import { render, staticRenderFns } from "./Coalitions.vue?vue&type=template&id=87423f04&scoped=true"
import script from "./Coalitions.vue?vue&type=script&lang=ts"
export * from "./Coalitions.vue?vue&type=script&lang=ts"
import style0 from "./Coalitions.vue?vue&type=style&index=0&id=87423f04&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87423f04",
  null
  
)

export default component.exports